"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyPressSequence = void 0;
const lodash_difference_1 = __importDefault(require("lodash.difference"));
const operators_1 = require("rxjs/operators");
function keyPresses(keyUp) {
    return observable => {
        return observable.pipe((0, operators_1.groupBy)(e => e.keyCode), (0, operators_1.mergeMap)(group => {
            return group.pipe((0, operators_1.windowWhen)(() => keyUp.pipe((0, operators_1.filter)(e => e.keyCode === group.key))), (0, operators_1.mergeMap)(window => window.pipe((0, operators_1.distinctUntilChanged)(), (0, operators_1.first)())));
        }));
    };
}
function multiKeyPresses(keyUp) {
    return observable => {
        return observable.pipe(keyPresses(keyUp), (0, operators_1.pluck)('keyCode'), (0, operators_1.bufferWhen)(() => keyUp), (0, operators_1.filter)(buffer => buffer.length > 0));
    };
}
function keyPressSequence(sequence, keydown, keyup) {
    return keydown.pipe(multiKeyPresses(keyup), (0, operators_1.bufferCount)(sequence.length), (0, operators_1.filter)(buffer => sequenceEquals(buffer, sequence)), (0, operators_1.mapTo)(true));
}
exports.keyPressSequence = keyPressSequence;
function sequenceEquals(sequence1, sequence2) {
    for (let i = 0; i < sequence1.length; i++) {
        const keySet1 = sequence1[i];
        const keySet2 = sequence2[i];
        if (keySet1.length !== keySet2.length) {
            return false;
        }
        if ((0, lodash_difference_1.default)(keySet1, keySet2).length > 0) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=keypresses.operator.js.map